import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSearchForm, setErrorMessage } from '../../stories/actions';
import { getSendPasswordResetEmail } from '../../services/api';
import { isEmpty, isValidEmail } from "../../utilities/methods";

import Footer from '../Footer/Footer';

import "./Form.css";

const FormResetPasswd = ({ users, setSearchFormAction, errorMessage, setErrorMessageAction }) => {
    const [email, setEmail] = useState("");

    const navigateTo = useNavigate();

    const handlerChangeEmail = (e) => {
        const value = e.target.value;
        setEmail(value);
    };

    const handlerKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }

        handlerSendEmailToResetPassword();
    };

    const handlerSendEmailToResetPassword = async () => {
        if (isEmpty(email)) {
            setErrorMessageAction("Este campo é obrigatório.");
        } else if (!isValidEmail(email)) {
            setErrorMessageAction("O endereço de e-mail fornecido não parece válido.");
        } else {
            const user = users.find(user => user.email.trim() === email.trim());

            if (user) {
                await getSendPasswordResetEmail(user).then(() => {
                    handlerUserResetPasswd();
                    setErrorMessageAction("");
                });
            }
        }
    };

    const handlerUserLogin = () => {
        setErrorMessageAction("");
        setSearchFormAction("login");
        navigateTo("/?page-login=true");
    };

    const handlerUserRegister = () => {
        setErrorMessageAction("");
        setSearchFormAction("register");
        navigateTo("/?page-register=true");
    };

    const handlerUserResetPasswd = () => {
        setErrorMessageAction("");
        setSearchFormAction("resetpasswd");
        navigateTo("/?page-resetpasswd=true");
    };

    return (
        <div className='row'>
            <div className='col-md-3'></div>

            <div className='col-md-12 form_container'>
                <div className='form_card'>
                    <div className="mb-2">
                        <small className={errorMessage ? "label_form_style response_message" : "label_form_style"}>{errorMessage}</small>
                    </div>

                    <div className="mb-4">
                        <h4 className='label_form_title_paragraph'>Formulário de envio de email</h4>
                    </div>

                    <div className="mb-4">
                        <label className="label_form_style">Email</label>
                        <input type='text'
                            value={email}
                            placeholder='nome@provedor.com'
                            onChange={handlerChangeEmail}
                            onKeyDown={handlerKeyPress}
                            className='form-control input_theme_style' />
                    </div>

                    <div className="mb-4 col-md-6">
                        <div className='button_group_container' onClick={handlerSendEmailToResetPassword}>
                            <span className="button_group_paragraph_style">Verificar Agora</span>
                            <span className="material-symbols-outlined button_group_icon_style"> send </span>
                        </div>
                    </div>

                    <div className="mb-2">
                        <span className='button_link_form_style' onClick={handlerUserLogin}>Tenho uma conta</span>
                    </div>

                    <div className="mb-2">
                        <span className='button_link_form_style' onClick={handlerUserRegister}>Registre-se</span>
                    </div>
                </div>
            </div>

            <div className='col-md-3'></div>

            <Footer />
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapActionToProps = (dispatch) => {
    return {
        setSearchFormAction: (searchForm) => dispatch(setSearchForm(searchForm)),
        setErrorMessageAction: (errorMessage) => dispatch(setErrorMessage(errorMessage))
    };
};

export default connect(mapStoreToProps, mapActionToProps)(FormResetPasswd);